import { CurrencyContext, useCurrency } from "./currency-context";

export function CurrencyContextProvider({
	children,
	value,
}: React.PropsWithChildren<{
	value: {
		venueId: string;
		tenant: string;
	};
}>) {
	return (
		<CurrencyContext value={useCurrency(value)}>
			<>{children}</>
		</CurrencyContext>
	);
}
